// Bilingual EN / FR copy
export const translations = {
  en: {
    nav: { home: "Home", requirements: "Requirements", how: "How It Works", apply: "Apply Now", admin: "Admin" },
    hero: {
      eyebrow: "International Male Model Casting",
      titleA: "Become The",
      titleB: "Face Of",
      titleC: "Premium",
      tagline: "We are hiring attractive male models for major underwear brand campaigns. If you have a fit body and strong presence, apply today.",
      cta: "Apply Now",
      ctaSecondary: "View Requirements",
    },
    brands: { title: "Work With The World's Top Underwear Brands", subtitle: "Calvin Klein · Armani · Hugo Boss · Tommy Hilfiger · Versace · Diesel · Ralph Lauren · Abercrombie" },
    inspiration: {
      eyebrow: "Inspiration",
      title: "The Campaigns You'll Star In",
      desc: "From editorial print to global digital campaigns — our models work with high-end production teams across Milan, Paris, New York, and Lisbon.",
    },
    requirements: {
      eyebrow: "Casting Criteria",
      title: "What We Look For",
      desc: "We work exclusively with confident, fit men who can carry a premium brand identity on camera.",
      items: [
        { label: "Age", value: "18 – 35 years" },
        { label: "Height", value: "Minimum 1.70m (5'7\")" },
        { label: "Body", value: "Athletic, Toned or Muscular" },
        { label: "Presence", value: "Strong on-camera confidence" },
      ],
      photosTitle: "Mandatory Photos",
      photos: [
        "Clear face photo — well lit, no sunglasses",
        "Full body in boxers only — front view",
        "Full body in boxers only — back view",
        "Full body wearing only briefs (slip) — front view",
        "Full body wearing only briefs (slip) — back view",
      ],
    },
    how: {
      eyebrow: "Process",
      title: "How It Works",
      steps: [
        { n: "01", title: "Submit", desc: "Complete the application with your measurements and photos." },
        { n: "02", title: "Review", desc: "Our casting team reviews your profile within 7 business days." },
        { n: "03", title: "Test Shoot", desc: "Selected candidates are invited for a paid test session." },
        { n: "04", title: "Sign", desc: "Sign with the agency and start booking premium brand campaigns." },
      ],
    },
    form: {
      eyebrow: "Application",
      title: "Submit Your Casting",
      sectionPersonal: "Personal Information",
      sectionContact: "Contact & Address",
      sectionSocial: "Social Media",
      sectionMeasures: "Measurements",
      sectionProfile: "Profile",
      sectionContent: "Content & Experience",
      sectionPhotos: "Mandatory Photos",
      sectionMessage: "Tell Us About You",
      fullName: "Full Name",
      artisticName: "Artistic Name / Nickname",
      age: "Age",
      nationality: "Nationality",
      street: "Street",
      streetNumber: "Number",
      city: "City",
      postalCode: "Postal Code",
      country: "Country",
      whatsapp: "WhatsApp Number",
      email: "Email Address",
      instagram: "Instagram",
      onlyfans: "OnlyFans",
      tiktok: "TikTok",
      height: "Height (cm)",
      weight: "Weight (kg)",
      chest: "Chest (cm)",
      waist: "Waist (cm)",
      hips: "Hips (cm)",
      arms: "Arms (cm)",
      thighs: "Thighs (cm)",
      underwearSize: "Underwear Size",
      bodyType: "Body Type",
      role: "Role Preference",
      coupleContent: "Do you do couple content?",
      coupleNote: "Note: only gay couples or male-male duos will be considered.",
      sexualOrientation: "Sexual Orientation (write freely)",
      experience: "Modeling / Content Creation Experience",
      followers: "Followers (total)",
      monthlyViews: "Monthly Views",
      engagement: "Average Engagement",
      availability: "Availability for photoshoots and travel",
      introduction: "Personal Introduction / Message",
      photoFace: "Face Photo",
      photoBody: "Full Body (Shirtless)",
      photoUnderwear: "Boxer Briefs (Front & Side)",
      photos: {
        face: "Face Photo",
        boxer_front: "Boxers — Front",
        boxer_back: "Boxers — Back",
        slippers_front: "Slippers Only — Front",
        slippers_back: "Slippers Only — Back",
      },
      photoHint: "JPG / PNG / WEBP · Max 10MB",
      photoBgNote: "All photos must preferably have a plain white background, with good natural lighting.",
      submit: "Submit Application",
      submitting: "Submitting...",
      disclaimer: "+18 only. By submitting, you confirm you are over 18 and consent to our privacy policy. Your data is encrypted and reviewed only by our casting team.",
      successTitle: "Application Received",
      successMsg: "Thank you. We will contact you soon to inform you of the result of your application. No automated email is sent — our casting team reaches out directly via WhatsApp or email.",
      yes: "Yes",
      no: "No",
    },
    footer: { rights: "All rights reserved.", terms: "Terms", privacy: "Privacy", contact: "Contact" },
    admin: {
      loginTitle: "Admin Access",
      loginSubtitle: "Restricted area — casting team only",
      email: "Email",
      password: "Password",
      signIn: "Sign In",
      dashboard: "Dashboard",
      applications: "Applications",
      total: "Total",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      logout: "Logout",
      name: "Name",
      ageCol: "Age",
      country: "Country",
      bodyType: "Body Type",
      status: "Status",
      submitted: "Submitted",
      view: "View",
      approve: "Approve",
      reject: "Reject",
      noApps: "No applications yet",
      back: "Back",
      photos: "Photos",
      details: "Details",
    },
  },
  fr: {
    nav: { home: "Accueil", requirements: "Critères", how: "Processus", apply: "Postuler", admin: "Admin" },
    hero: {
      eyebrow: "Casting Mannequin Masculin International",
      titleA: "Devenez le",
      titleB: "Visage des",
      titleC: "Marques Premium",
      tagline: "Nous recrutons des mannequins masculins attractifs pour les campagnes des plus grandes marques de sous-vêtements. Si vous avez un corps en forme et une présence forte, postulez aujourd'hui.",
      cta: "Postuler",
      ctaSecondary: "Voir les Critères",
    },
    brands: { title: "Travaillez avec les Plus Grandes Marques", subtitle: "Calvin Klein · Armani · Hugo Boss · Tommy Hilfiger · Versace · Diesel · Ralph Lauren · Abercrombie" },
    inspiration: {
      eyebrow: "Inspiration",
      title: "Les Campagnes Qui Vous Attendent",
      desc: "De l'éditorial print aux campagnes digitales mondiales — nos mannequins travaillent avec des équipes de production haut de gamme à Milan, Paris, New York et Lisbonne.",
    },
    requirements: {
      eyebrow: "Critères de Casting",
      title: "Ce Que Nous Recherchons",
      desc: "Nous travaillons exclusivement avec des hommes confiants et en forme capables d'incarner une identité de marque premium.",
      items: [
        { label: "Âge", value: "18 – 35 ans" },
        { label: "Taille", value: "Minimum 1,70m" },
        { label: "Corps", value: "Athlétique, Tonique ou Musclé" },
        { label: "Présence", value: "Charisme à la caméra" },
      ],
      photosTitle: "Photos Obligatoires",
      photos: [
        "Photo du visage — bien éclairée, sans lunettes",
        "Plein corps en boxer uniquement — vue de face",
        "Plein corps en boxer uniquement — vue de dos",
        "Plein corps en slip uniquement — vue de face",
        "Plein corps en slip uniquement — vue de dos",
      ],
    },
    how: {
      eyebrow: "Processus",
      title: "Comment Ça Marche",
      steps: [
        { n: "01", title: "Postuler", desc: "Complétez le formulaire avec vos mesures et photos." },
        { n: "02", title: "Évaluation", desc: "Notre équipe de casting examine votre profil sous 7 jours ouvrés." },
        { n: "03", title: "Test Shoot", desc: "Les candidats sélectionnés sont invités pour une séance test rémunérée." },
        { n: "04", title: "Signature", desc: "Signez avec l'agence et démarrez vos campagnes premium." },
      ],
    },
    form: {
      eyebrow: "Candidature",
      title: "Soumettez Votre Casting",
      sectionPersonal: "Informations Personnelles",
      sectionContact: "Contact & Adresse",
      sectionSocial: "Réseaux Sociaux",
      sectionMeasures: "Mensurations",
      sectionProfile: "Profil",
      sectionContent: "Contenu & Expérience",
      sectionPhotos: "Photos Obligatoires",
      sectionMessage: "Parlez-Nous de Vous",
      fullName: "Nom Complet",
      artisticName: "Nom Artistique / Surnom",
      age: "Âge",
      nationality: "Nationalité",
      street: "Rue",
      streetNumber: "Numéro",
      city: "Ville",
      postalCode: "Code Postal",
      country: "Pays",
      whatsapp: "Numéro WhatsApp",
      email: "Email",
      instagram: "Instagram",
      onlyfans: "OnlyFans",
      tiktok: "TikTok",
      height: "Taille (cm)",
      weight: "Poids (kg)",
      chest: "Poitrine (cm)",
      waist: "Taille (cm)",
      hips: "Hanches (cm)",
      arms: "Bras (cm)",
      thighs: "Cuisses (cm)",
      underwearSize: "Taille de Sous-Vêtement",
      bodyType: "Type de Corps",
      role: "Préférence de Rôle",
      coupleContent: "Faites-vous du contenu en couple ?",
      coupleNote: "Note : uniquement couples gays ou duos homme-homme.",
      sexualOrientation: "Orientation sexuelle (texte libre)",
      experience: "Expérience Modèle / Création de Contenu",
      followers: "Abonnés (total)",
      monthlyViews: "Vues Mensuelles",
      engagement: "Engagement Moyen",
      availability: "Disponibilité pour shootings et voyages",
      introduction: "Présentation Personnelle / Message",
      photoFace: "Photo du Visage",
      photoBody: "Plein Corps (Torse Nu)",
      photoUnderwear: "Boxer (Face & Profil)",
      photos: {
        face: "Photo du Visage",
        boxer_front: "Boxer — Face",
        boxer_back: "Boxer — Dos",
        slippers_front: "Slip — Face",
        slippers_back: "Slip — Dos",
      },
      photoHint: "JPG / PNG / WEBP · Max 10MB",
      photoBgNote: "Toutes les photos doivent de préférence avoir un fond blanc uni, avec un bon éclairage naturel.",
      submit: "Envoyer ma Candidature",
      submitting: "Envoi en cours...",
      disclaimer: "+18 uniquement. En soumettant, vous confirmez avoir plus de 18 ans et acceptez notre politique de confidentialité.",
      successTitle: "Candidature Reçue",
      successMsg: "Merci. Nous vous contacterons prochainement pour vous informer du résultat de votre candidature. Aucun email automatique n'est envoyé — notre équipe casting vous contacte directement via WhatsApp ou email.",
      yes: "Oui",
      no: "Non",
    },
    footer: { rights: "Tous droits réservés.", terms: "CGU", privacy: "Confidentialité", contact: "Contact" },
    admin: {
      loginTitle: "Accès Admin",
      loginSubtitle: "Zone réservée — équipe casting uniquement",
      email: "Email",
      password: "Mot de passe",
      signIn: "Connexion",
      dashboard: "Tableau de bord",
      applications: "Candidatures",
      total: "Total",
      pending: "En attente",
      approved: "Acceptés",
      rejected: "Rejetés",
      logout: "Déconnexion",
      name: "Nom",
      ageCol: "Âge",
      country: "Pays",
      bodyType: "Type",
      status: "Statut",
      submitted: "Envoyé",
      view: "Voir",
      approve: "Accepter",
      reject: "Rejeter",
      noApps: "Aucune candidature",
      back: "Retour",
      photos: "Photos",
      details: "Détails",
    },
  },
  pt: {
    nav: { home: "Início", requirements: "Requisitos", how: "Como Funciona", apply: "Candidatar", admin: "Admin" },
    hero: {
      eyebrow: "Casting Internacional de Modelos Masculinos",
      titleA: "Sê o",
      titleB: "Rosto das",
      titleC: "Marcas Premium",
      tagline: "Procuramos modelos masculinos atraentes para campanhas das maiores marcas de roupa interior. Se tens um corpo em forma e presença forte, candidata-te hoje.",
      cta: "Candidatar",
      ctaSecondary: "Ver Requisitos",
    },
    brands: { title: "Trabalha com as Maiores Marcas de Roupa Interior do Mundo", subtitle: "Calvin Klein · Armani · Hugo Boss · Tommy Hilfiger · Versace · Diesel · Ralph Lauren · Abercrombie" },
    inspiration: {
      eyebrow: "Inspiração",
      title: "As Campanhas em Que Vais Brilhar",
      desc: "Da fotografia editorial às campanhas digitais globais — os nossos modelos trabalham com equipas de produção de topo em Milão, Paris, Nova Iorque e Lisboa.",
    },
    requirements: {
      eyebrow: "Critérios do Casting",
      title: "O Que Procuramos",
      desc: "Trabalhamos exclusivamente com homens confiantes e em forma, capazes de transmitir a identidade de uma marca premium em câmara.",
      items: [
        { label: "Idade", value: "18 – 35 anos" },
        { label: "Altura", value: "Mínimo 1,70m" },
        { label: "Corpo", value: "Atlético, Tonificado ou Musculado" },
        { label: "Presença", value: "Forte presença em câmara" },
      ],
      photosTitle: "Fotos Obrigatórias",
      photos: [
        "Foto do rosto — bem iluminada, sem óculos de sol",
        "Corpo inteiro só de boxers — vista de frente",
        "Corpo inteiro só de boxers — vista de trás",
        "Corpo inteiro só de slip (cueca tipo slip) — vista de frente",
        "Corpo inteiro só de slip (cueca tipo slip) — vista de trás",
      ],
    },
    how: {
      eyebrow: "Processo",
      title: "Como Funciona",
      steps: [
        { n: "01", title: "Enviar", desc: "Completa a candidatura com as tuas medidas e fotos." },
        { n: "02", title: "Avaliação", desc: "A nossa equipa de casting analisa o teu perfil em 7 dias úteis." },
        { n: "03", title: "Sessão Teste", desc: "Os candidatos selecionados são convidados para uma sessão teste paga." },
        { n: "04", title: "Assinar", desc: "Assina com a agência e começa a fechar campanhas premium." },
      ],
    },
    form: {
      eyebrow: "Candidatura",
      title: "Envia a Tua Candidatura",
      sectionPersonal: "Dados Pessoais",
      sectionContact: "Contacto & Morada",
      sectionSocial: "Redes Sociais",
      sectionMeasures: "Medidas",
      sectionProfile: "Perfil",
      sectionContent: "Conteúdo & Experiência",
      sectionPhotos: "Fotos Obrigatórias",
      sectionMessage: "Fala-nos Sobre Ti",
      fullName: "Nome Completo",
      artisticName: "Nome Artístico / Alcunha",
      age: "Idade",
      nationality: "Nacionalidade",
      street: "Rua",
      streetNumber: "Número",
      city: "Cidade",
      postalCode: "Código Postal",
      country: "País",
      whatsapp: "Número WhatsApp",
      email: "Email",
      instagram: "Instagram",
      onlyfans: "OnlyFans",
      tiktok: "TikTok",
      height: "Altura (cm)",
      weight: "Peso (kg)",
      chest: "Peito (cm)",
      waist: "Cintura (cm)",
      hips: "Anca (cm)",
      arms: "Braços (cm)",
      thighs: "Coxas (cm)",
      underwearSize: "Tamanho de Roupa Interior",
      bodyType: "Tipo de Corpo",
      role: "Papel Preferido",
      coupleContent: "Fazes conteúdo de casal?",
      coupleNote: "Nota: apenas casais gay ou duplas homem-homem serão consideradas.",
      sexualOrientation: "Orientação Sexual (texto livre)",
      experience: "Experiência como Modelo / Criação de Conteúdo",
      followers: "Seguidores (total)",
      monthlyViews: "Visualizações Mensais",
      engagement: "Engagement Médio",
      availability: "Disponibilidade para sessões e viagens",
      introduction: "Apresentação Pessoal / Mensagem",
      photoFace: "Foto do Rosto",
      photoBody: "Corpo Inteiro (Sem Camisa)",
      photoUnderwear: "Boxers (Frente & Lado)",
      photos: {
        face: "Foto do Rosto",
        boxer_front: "Boxers — Frente",
        boxer_back: "Boxers — Trás",
        slippers_front: "Slip — Frente",
        slippers_back: "Slip — Trás",
      },
      photoHint: "JPG / PNG / WEBP · Máx 10MB",
      photoBgNote: "As fotos devem, de preferência, ter fundo branco liso e boa iluminação natural.",
      submit: "Enviar Candidatura",
      submitting: "A enviar...",
      disclaimer: "Apenas +18. Ao submeter, confirmas que tens mais de 18 anos e aceitas a nossa política de privacidade. Os teus dados são encriptados e analisados apenas pela nossa equipa de casting.",
      successTitle: "Candidatura Recebida",
      successMsg: "Obrigado. Entraremos em contacto brevemente para te informar do resultado da candidatura. Não é enviado qualquer email automático — a nossa equipa de casting contacta diretamente via WhatsApp ou email.",
      yes: "Sim",
      no: "Não",
    },
    footer: { rights: "Todos os direitos reservados.", terms: "Termos", privacy: "Privacidade", contact: "Contacto" },
    admin: {
      loginTitle: "Acesso Admin",
      loginSubtitle: "Área restrita — apenas equipa de casting",
      email: "Email",
      password: "Palavra-passe",
      signIn: "Entrar",
      dashboard: "Painel",
      applications: "Candidaturas",
      total: "Total",
      pending: "Pendentes",
      approved: "Aprovadas",
      rejected: "Rejeitadas",
      logout: "Sair",
      name: "Nome",
      ageCol: "Idade",
      country: "País",
      bodyType: "Tipo",
      status: "Estado",
      submitted: "Enviada",
      view: "Ver",
      approve: "Aprovar",
      reject: "Rejeitar",
      noApps: "Sem candidaturas",
      back: "Voltar",
      photos: "Fotos",
      details: "Detalhes",
    },
  },
};

export const bodyTypeOptions = ["Slim", "Athletic", "Muscular", "Toned", "Fitness Model"];
export const roleOptions = ["Top", "Versatile", "Bottom", "Prefer not to say"];
